'use client';

import * as React from 'react';

/**
 * @useClient
 */
export const Edit = React.memo(function Edit() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
      <path fill="#868687" fillRule="evenodd" d="m12.19 4.01 3.662 3.675L5.592 17.98l-3.66-3.675L12.192 4.01Zm6.44-.886-1.633-1.64a1.616 1.616 0 0 0-2.289 0l-1.564 1.57 3.661 3.675L18.63 4.9c.489-.492.489-1.284 0-1.775ZM1.01 18.477a.417.417 0 0 0 .504.497l4.08-.992-3.66-3.675-.924 4.17Z" clipRule="evenodd" />
    </svg>;
});